enum ConditionDocumentApprovalStatusEnum {
    Approved = 'APPROVED',
    Legacy = 'LEGACY',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
}

export default ConditionDocumentApprovalStatusEnum;
